<template>
  <page>
    <page-title>Nutzungsbedingungen</page-title>
  </page>
</template>

<script>
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'TermsDE',
  mixins: [PageMixin],
  created () {
    this.$emit('loadingDone')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/static/de/Terms.vue